module.exports = __webpack_public_path__ + "media/assets/images/consultant-d1c23751fe82f9eb171686a808a170f6.jpg";